"use client"

import { useContentfulLiveUpdates } from "@contentful/live-preview/react"

import PressRelease from "../PressRelease"
import type { TPressRelease } from "../PressRelease/PressRelease"

export default function LivePreviewWrapper({
  pressRelease,
}: {
  pressRelease: TPressRelease
}) {
  const pressReleaseUpdated = useContentfulLiveUpdates(pressRelease)

  return <PressRelease pressRelease={pressReleaseUpdated} />
}
